export default __webpack_public_path__ + "static/media/a1.b99eda40.jpg";